import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { InlineNotification, useLocalizeMessage } from 'libs.nucleus';
import { TranslationWorkbenchContext } from '../../contexts';
import { validateL10nMap } from '../../utils/validate_l10n_map';
export const L10nMapSyncErrorNotification = () => {
    const { l10nMap, studyAssets, libraryAssets, resourcesAssets, notificationsAssets, resourcesPdfAssets } = useContext(TranslationWorkbenchContext);
    const allAssets = {
        ...libraryAssets,
        ...resourcesAssets,
        ...resourcesPdfAssets,
        ...studyAssets,
        ...notificationsAssets,
    };
    const t = useLocalizeMessage();
    const { isValid: isL10nMapValid, errors: l10nMapErrors } = validateL10nMap(l10nMap, allAssets);
    if (!isL10nMapValid) {
        l10nMapErrors.forEach((error) => {
            console.log('Sync Error:', error);
        });
        return (_jsx(InlineNotification, { title: t('Some error occurred while syncing localization status'), subtitle: t('Try disabling and then re-enabling translations to resolve the issue. If the problem persists, please contact support.'), type: 'error' }));
    }
    return null;
};
